import { useDAL } from '@/contexts/useDAL';
import { PreferencesKey } from '@/data/dal/preferencesKey';
import type { BackupVault } from '@/data/vaults/backupVault';
import type { BackupVaultPreferences } from '@/data/vaults/backupVaultPreferences';
export const useBackupVaultColorUpdate = () => {
  const dal = useDAL();
  const {
    data: pref,
    isLoading: prefLoading
  } = dal.preferences.useAccountPref(PreferencesKey.BackupVault);
  const updateVaultColor = async (vault: BackupVault) => {
    if (vault.backgroundColor && !prefLoading) {
      if (!pref?.value) {
        await dal.preferences.updateAccountPref(PreferencesKey.BackupVault, {
          colors: [{
            id: vault.id,
            color: vault.backgroundColor
          }]
        } satisfies BackupVaultPreferences);
      } else {
        const vpref = pref.value.colors.find(p => p.id === vault.id);
        if (vpref) {
          vpref.color = vault.backgroundColor;
        } else {
          pref.value.colors.push({
            id: vault.id,
            color: vault.backgroundColor
          });
        }
        await dal.preferences.updateAccountPref(PreferencesKey.BackupVault, pref.value);
      }
    }
  };
  return {
    updateVaultColor
  };
};